import Bugsnag from '@bugsnag/js'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

Bugsnag.start({
  apiKey: 'c915fbdfdf178bc0c55ed53a783c38e8',
  onError: (event) => {
    return event.errors.some((error) => {
      return error.stacktrace.some((frame) => frame.file && frame.file.includes('widgets.allocate.co.uk'))
    })
  },
})

const loadApp = () => {
  window.__allocate_handleError = (e) => {
    if (Bugsnag && Bugsnag.notify && e instanceof Error) {
      Bugsnag.notify(e)
    }
    console.error(e)
  }

  require('../build/templates')
  require('./app/main')
}

// Load app with jQuery noConflict
;(function () {
  if (typeof window.jQuery !== 'undefined' && window.jQuery !== null && window.jQuery.noConflict) {
    var ncJQuery = window.jQuery.noConflict()
    window.jQuery = window.$ = null
  }
  loadApp()
  if (ncJQuery) {
    window.jQuery = window.$ = ncJQuery
  }
})()
